import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import _ from 'lodash';

const State = new Record({
    events: null,
    selectEvent: null,
    processing: false,
    fails: null,
});

function getSelectedEvent(events) {
    if (!events)
        return null;

    return _.find(events, function (event) {
        return event.selected;
    });
}

class ImportacaoStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
            case ActionTypes.SELECT_EVENTS_START:
                return state.clear();

            case ActionTypes.SELECT_EVENTS_FINISH:
                return state
                    .set('events', action.events)
                    .set('selectEvent', getSelectedEvent(action.events));

            case ActionTypes.SELECT_EVENT_FOR_IMPORT:
                return state
                    .set('selectEvent', state.events ? _.find(state.events, e => e.id === action.eventId) : null);

            case ActionTypes.IMPORT_SHEET_START:
                return state.set('processing', true).set('fails', null);

            case ActionTypes.IMPORT_SHEET_FINISH:
                return state.set('processing', false).set('fails', action.fails);

            case ActionTypes.IMPORT_SHEET_FAILED:
                return state.set('processing', false);

            default:
                return state;
        }
    }
}

export default new ImportacaoStore();



// WEBPACK FOOTER //
// src/stores/ImportacaoStore.js